import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { setRemainingAiImageGenerations } from 'store/models/aiImageGeneration';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchRemainingAiImageGenerations = (): AppThunkAction => {
    return (dispatch) => {
        return fetcher
            .get<unknown, { generationsLeft: number }>('/api/v1/images/ai/limits')
            .then((response) => {
                const { generationsLeft } = response;
                dispatch(setRemainingAiImageGenerations(generationsLeft));
            })
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.AiImageGenerationSomethingWentWrong));
            });
    };
};
